module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "datatable"
    }
  }, [_c('v-data-table', {
    class: _vm.$attrs.customWidth ? 'width_control' : '',
    attrs: {
      "single-select": "",
      "headers": _vm.headers,
      "items": _vm.currentPageItems,
      "page": _vm.currentPage,
      "items-per-page": _vm.customPaginationPerPage,
      "item-key": "no",
      "hide-default-footer": "",
      "loading": _vm.tableLoading,
      "loading-text": "Memuat data...",
      "height": "auto"
    },
    on: {
      "update:page": function($event) {
        _vm.currentPage = $event
      },
      "dblclick:row": _vm.selectRowAndFinish,
      "click:row": _vm.rowClick
    },
    scopedSlots: _vm._u([(_vm.$scopedSlots['no-data']) ? {
      key: "no-data",
      fn: function() {
        return [_vm._t("no-data")]
      },
      proxy: true
    } : null, {
      key: "top",
      fn: function() {
        return [_c('v-card-text', {
          staticClass: "py-0"
        }, [_c('v-container', {
          attrs: {
            "fluid": ""
          }
        }, [_c('v-row', {
          staticClass: "my-3"
        }, [_c('v-col', {
          attrs: {
            "cols": "*"
          }
        }, [_c('v-text-field', {
          staticClass: "search_box",
          attrs: {
            "id": "datatable_search",
            "outlined": "",
            "height": "36px",
            "hide-details": "",
            "placeholder": "Ketik kata kunci dan tekan enter"
          },
          on: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.doBasicFilter()
            }
          },
          model: {
            value: (_vm.query),
            callback: function($$v) {
              _vm.query = $$v
            },
            expression: "query"
          }
        }, [_c('template', {
          slot: "prepend-inner"
        }, [_c('svg', {
          attrs: {
            "width": "20",
            "height": "20",
            "viewBox": "0 0 20 20",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z",
            "fill": "#073554"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z",
            "fill": "#073554"
          }
        })])])], 2)], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "item.label",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', [_vm._v(_vm._s(item.label ? item.label.replace(/ /g, " ") : item.label))])]
      }
    }, {
      key: "item.picture",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "py-3"
        }, [_c('img', {
          staticStyle: {
            "border-radius": "5px"
          },
          attrs: {
            "src": item.picture,
            "width": "100%"
          }
        })])]
      }
    }, {
      key: "item.no",
      fn: function(ref) {
        var index = ref.index;

        return [_vm._v("\n            " + _vm._s((_vm.customPaginationPerPage || 10) * (_vm.currentPage - 1) +
          (index + 1)) + "\n        ")]
      }
    }, {
      key: "item.is_restricted",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.is_restricted) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])]
      }
    }, {
      key: "item.is_home",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.is_home) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])]
      }
    }, {
      key: "item.is_live_class",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.is_live_class) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])]
      }
    }, {
      key: "item.is_specific",
      fn: function(ref) {
        var item = ref.item;

        return [(item.is_specific != null) ? _c('div', [(item.is_specific) ? _c('v-icon', {
          attrs: {
            "color": "green3"
          }
        }, [_vm._v("mdi-checkbox-marked")]) : _c('v-icon', {
          attrs: {
            "color": "darkFade"
          }
        }, [_vm._v("mdi-close-box")])], 1) : _vm._e()]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.status === 'TO_DO') ? _c('v-btn', {
          staticStyle: {
            "color": "#ffffff"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#EB3123"
          }
        }, [_vm._v("\n                To Do\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'DONE') ? _c('v-btn', {
          staticStyle: {
            "color": "#00cf3f"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#BCF8CC"
          }
        }, [_vm._v("\n                Done\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'IN_PROGRESS') ? _c('v-btn', {
          staticStyle: {
            "color": "#0e97d6"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E1F4FC"
          }
        }, [_vm._v("\n                In Progress\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'PUBLISHED') ? _c('v-btn', {
          staticStyle: {
            "color": "#40bf75"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#EEFFE0"
          }
        }, [_vm._v("\n                Publikasi\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'DRAFT') ? _c('v-btn', {
          staticStyle: {
            "color": "orange"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#FFF3E0"
          }
        }, [_vm._v("\n                Draft\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'REVIEW') ? _c('v-btn', {
          staticStyle: {
            "color": "#2690cb"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E8F5FA"
          }
        }, [_vm._v("\n                Review\n            ")]) : _vm._e()]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [(
          _vm.$route.name === 'ModulPembelajaranReport' ||
          _vm.$route.name === 'VdPembelajaranReport'
        ) ? _c('a', {
          staticStyle: {
            "color": "#0e97d6",
            "text-decoration": "underline",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.selectRowAndFinish(item.no)
            }
          }
        }, [_vm._v("\n                Lihat Detail\n            ")]) : _vm._e(), _vm._v(" "), (_vm.hasAction) ? _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([(
            _vm.$route.name === 'ModulPembelajaran' ||
            _vm.$route.name === 'VideoPembelajaran'
          ) ? {
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('div', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'div', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "#4F4F4F",
                  "id": "datatable_dot_btn"
                }
              }, [_vm._v("mdi-dots-vertical")])], 1)]
            }
          } : null], null, true)
        }, [_vm._v(" "), _c('v-list', [(_vm.hasEdit) ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_detail_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_detail_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.selectRowAndFinish(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Detail")])], 1), _vm._v(" "), _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.duplicateItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Duplikat")])], 1), _vm._v(" "), (_vm.$route.name != 'AmbisMeter') ? _c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_delete_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Hapus")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasDuplicate) ? _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('div', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'div', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "#4F4F4F",
                  "id": "datatable_dot_btn"
                }
              }, [_vm._v("\n                            mdi-dots-vertical\n                        ")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "id": "datatable_duplicate_btn",
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.duplicateItem(item.no)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Duplicate")])], 1)], 1)], 1) : _vm._e()]
      }
    }], null, true)
  }), _vm._v(" "), (_vm.hasCustomPagination && _vm.customPaginationTotalPages === 0) ? _c('div', {
    staticClass: "d-flex space-between pa-4"
  }, [_c('span', {
    staticClass: "gray3--text"
  }, [_vm._v("\n            Menampilkan " + _vm._s(_vm.items.length * _vm.currentPage) + " dari -\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "depressed": "",
      "disabled": _vm.currentPage == 1,
      "min-width": "32px",
      "height": "32px"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(--_vm.currentPage)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0 mx-2",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "blew",
      "min-width": "32px",
      "height": "32px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentPage) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "depressed": "",
      "min-width": "32px",
      "height": "32px",
      "disabled": _vm.items.length < _vm.customPaginationPerPage
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(++_vm.currentPage)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1) : _c('div', {
    staticClass: "d-flex align-center space-between pa-4"
  }, [_c('span', {
    staticClass: "gray3--text"
  }, [_vm._v("\n            Menampilkan\n            " + _vm._s(_vm.customPaginationPerPage * (_vm.currentPage - 1) + 1) + "\n            sampai\n            " + _vm._s(_vm.customPaginationPerPage * _vm.currentPage > _vm.items.length ?
    _vm.customPaginationTotalItems ?
    _vm.customPaginationTotalItems :
    _vm.customPaginationPerPage * (_vm.currentPage - 1) +
    _vm.items.length :
    _vm.customPaginationPerPage * _vm.currentPage) + "\n            dari\n            " + _vm._s(_vm.customPaginationTotalItems ?
    _vm.customPaginationTotalItems + " entri" :
    " -") + "\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "color": "blew",
      "length": _vm.maxPage,
      "total-visible": 7
    },
    on: {
      "input": _vm.currentPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512fbfd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/DataTableModule.vue
// module id = 1866
// module chunks = 1